/**
 * Created by lucamontanera on 13/09/16.
 */
class Filter {
    constructor(struttura = {}) {
        this.fil = [];
    }

    set filter(filter) {
        filter = filter.map(item => {
            if(item && item.data){
                item.data.path = _.trim(item.data.path);
                item.data.name = _.trim(item.data.name);
            }

            return item;
        });
        filter = _.uniqBy(filter,  item => item.data.path);
        this.fil = this._calculateFilter(filter.filter(fil => fil.data.name), "/", 1);
    }

    get filter() {
        return this.fil;
    }

    getRoot(confront) {
        return this.fil.filter(item =>
            item.data.path === confront || item.data.name === confront || item.data.id === confront || this._isPresent(item.children, confront)
        );
    }

    getSingle(confront) {
        return this._search(this.fil, confront);
    }

    getValueBy(confront, excludeRoot = false) {
        let single = this.getSingle(confront);
        if (!single) { return []; }
        if (excludeRoot) {
            return this._flatten(this._allValue(single.children));
        } else {
            return this._flatten(this._allValue([single]));
        }
    }

    getAllValueBy(confront, excludeRoot = false) {
        let root = this.getRoot(confront);
        if (!root.length) return [];

        if (excludeRoot) {
            return this._flatten(this._allValue(root[0].children));
        } else {
            return this._flatten(this._allValue(root));
        }
    }

    getLeafs(confront) {
        return this._leaf(this.getRoot(confront));
    }

    getTotalCount(confront) {
        return this.getRoot(confront)[0].count;
    }

    has(confront) {
        return this._isPresent(this.fil, confront);
    }

    _calculateFilter(lista, value, i) {
        return lista
            .filter(item => {
                if (item.data.path.indexOf('\\/') > 0) {
                    let k = item.data.path.split('\\').length;
                    let j = i;
                    j += (k > 1) ? k -1 : 0;
                    return item.data.path.startsWith(value) && (value === '/' || (!item.data.path[value.length] || item.data.path[value.length] == '/'))  && item.data.path.split('/').length === j + 1;
                } else {
                    return item.data.path.startsWith(value) && (value === '/' || (!item.data.path[value.length] || item.data.path[value.length] == '/'))  && item.data.path.split('/').length === i + 1;
                }
            })
            .map(item => {
                item.children = this._calculateFilter(lista, item.data.path, i + 1);
                return item;
            });
    }

    _isPresent(list, confront) {
        return list
                .filter(item =>
                    item.data.path === confront || item.data.name === confront || item.data.id === confront || this._isPresent(item.children, confront)
                )
                .length > 0;
    }

    _allValue(list) {
        return list
            .filter(item => item.data)
            .map(item => [{'label': item.data.name,'filter': {data: item.data, count: item.count}}, ...this._allValue(item.children)]);
    }

    _flatten(arr) {
        return arr.reduce((flat, toFlatten) => {
            return flat.concat(Array.isArray(toFlatten) ? this._flatten(toFlatten) : toFlatten);
        }, []);
    }

    _search(list, confront) {
        for (let item of list)  {
            if (item.data.path === confront) {
                return item;
            } else {
                let i = this._search(item.children, confront);
                if (i !== null) {
                    return i;
                }
            }
        }
        return null;
    }

    _leaf(list) {
        return list.reduce((old, elem) => {
            if (elem.children.length > 0 ) {
                old.push(...this._leaf(elem.children))
            } else {
                old.push(elem);
            }

            return old;
        }, []);
    }
}

angular.module("app")
.factory("FilterService", function() {
    return {
        getInstance: function () {
            return new Filter();
        }
    };
});



// WEBPACK FOOTER //
// ./src/js/filter-service.js